import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Link } from '@remix-run/react';
import { CommunityResourceThumbnail } from '@shared/dream-components';

import { COMMUNITY_ROUTES } from '~/constants/community';
import type { CommunitySearchResource } from '~/interfaces/community';

interface ResourceResultRowProps {
  resource: CommunitySearchResource;
  onClick?: () => void;
}

export const ResourceResultRow: FC<ResourceResultRowProps> = ({ resource, onClick }) => {
  const { t } = useTranslation();

  const subtitle = [
    t('community.search.content_in_page', { page: resource.page.name }),
    resource.content_tags.map((tag) => tag.display).join(', '),
  ]
    .filter(Boolean)
    .join(' · ');

  return (
    <Link
      to={COMMUNITY_ROUTES.pageResource(resource.page.slug, resource.slug)}
      onClick={onClick}
      className="flex items-center gap-2 h-[72px] py-4 pr-4 pl-2 hover:bg-black/5 transition-colors"
    >
      <CommunityResourceThumbnail
        fileFormat={resource.file_format}
        url={resource.image_url}
        size="xs"
        locked={false}
        lockedLabel=""
        className="size-8 rounded-md"
      />
      <div className="flex flex-col justify-center gap-1 min-w-0 flex-1 pr-4 pl-1">
        <span className="truncate text-[15px] leading-5 font-semibold tracking-[-0.01em] text-black">
          {resource.title}
        </span>
        <span className="truncate text-[13px] leading-4 tracking-[-0.01em] text-black/70">{subtitle}</span>
      </div>
    </Link>
  );
};
